import React, { useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import viamericasLogo from '../assets/images/viamericas.svg';
import './Header.scss';

const LANGUAGES = [
  { code: 'en', label: 'EN', name: 'English' },
  { code: 'es', label: 'ES', name: 'Español' },
];

const Header = () => {
  const { i18n } = useTranslation();
  const [isOpen, setIsOpen] = useState(false);
  const menuRef = useRef(null);

  const currentCode = (i18n.language || 'es').slice(0, 2);
  const currentLanguage =
    LANGUAGES.find((lang) => lang.code === currentCode) || LANGUAGES[0];

  const changeLanguage = (code) => {
    i18n.changeLanguage(code);
    localStorage.setItem('i18nextLng', code);
    setIsOpen(false);
  };

  // Close the dropdown on outside click or Escape for accessibility.
  useEffect(() => {
    if (!isOpen) return undefined;

    const handlePointerDown = (event) => {
      if (menuRef.current && !menuRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };

    const handleKeyDown = (event) => {
      if (event.key === 'Escape') setIsOpen(false);
    };

    document.addEventListener('mousedown', handlePointerDown);
    document.addEventListener('keydown', handleKeyDown);

    return () => {
      document.removeEventListener('mousedown', handlePointerDown);
      document.removeEventListener('keydown', handleKeyDown);
    };
  }, [isOpen]);

  return (
    <header className="app-header">
      <div className="app-header__container">
        <div className="app-header__logo">
          <img src={viamericasLogo} alt="Viamericas" />
        </div>

        <div className="app-header__language" ref={menuRef}>
          <button
            type="button"
            className="language-select"
            onClick={() => setIsOpen((open) => !open)}
            aria-haspopup="listbox"
            aria-expanded={isOpen}
            aria-label="Select language"
          >
            <span className="language-select__current">{currentLanguage.label}</span>
            <svg
              className={`language-select__chevron ${isOpen ? 'is-open' : ''}`}
              width="14"
              height="14"
              viewBox="0 0 24 24"
              fill="none"
              aria-hidden="true"
            >
              <path
                d="M6 9l6 6 6-6"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </button>

          {isOpen && (
            <ul className="language-menu" role="listbox" aria-label="Languages">
              {LANGUAGES.map((lang) => (
                <li key={lang.code} role="none">
                  <button
                    type="button"
                    role="option"
                    aria-selected={lang.code === currentLanguage.code}
                    className={`language-menu__option ${
                      lang.code === currentLanguage.code ? 'is-active' : ''
                    }`}
                    onClick={() => changeLanguage(lang.code)}
                  >
                    {lang.name}
                  </button>
                </li>
              ))}
            </ul>
          )}
        </div>
      </div>
    </header>
  );
};

export default Header;
